/**
 * The cells both bid tables draw the same way.
 *
 * A lane, a timestamp and the post's notes mean the same thing on the dispatchers' page and the drivers'
 * one, and they were written once already — copying them into the second page is how two tables start
 * formatting the same field differently.
 */
import * as React from 'react'
import Tooltip from '@mui/joy/Tooltip'
import Typography from '@mui/joy/Typography'

export const place = (city?: string, state?: string): string => [city, state].filter(Boolean).join(', ') || '—'

/** Local time, because a staff member reads this against their own day. */
export const when = (iso: string): string => new Date(iso).toLocaleString()

/**
 * The post's own notes, trimmed to a line with the rest on hover.
 *
 * Shown rather than dropped: the notes are what the bidder was reading when they picked the number,
 * and a bid of $820 makes a different kind of sense next to "team driver, hazmat, 2 stops".
 */
export const Notes = ({ text }: { text?: string }) => {
    if (!text)
        return (
            <Typography level="body-xs" textColor="text.tertiary">
                —
            </Typography>
        )
    return (
        <Tooltip title={text} placement="top" sx={{ maxWidth: 420 }}>
            <Typography level="body-xs" sx={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {text}
            </Typography>
        </Tooltip>
    )
}
